/**
 * Safely parse JSON from localStorage/sessionStorage/cookies.
 * Returns null for missing, empty, or invalid values (including literal "undefined").
 */
export const parseStoredJson = (raw) => {
  if (raw == null || raw === "" || raw === "undefined" || raw === "null") {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const getLocalStorageJson = (key) =>
  parseStoredJson(localStorage.getItem(key));
